import AgoraRTC from "agora-rtc-sdk-ng"
import AgoraRTM from 'agora-rtm-sdk'
import microphone from '../../assets/microphone.svg'
import video from '../../assets/video.svg'
import leave from '../../assets/leave.svg'
import shareScreen from '../../assets/share-screen.png'
import askFacilitator from '../../assets/ask-facilitator.png'
import broadcastLogo from '../../assets/broadcast-logo.svg'
import chatLogo from '../../assets/chat-logo.svg'
import participantLogo from '../../assets/participants-logo.svg'
import infoDiskusiLogo from '../../assets/info-diskusi-logo.png'
import sendMessageLogo from '../../assets/send-message-logo.png'
import facilitatorInstructionLogo from '../../assets/facilitator-instruction-logo.png'
import { useEffect, useRef } from "react"
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getTimeReturnValues } from './components/RoomTimer/hooks/useCountdown';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import './Room.css'
import RoomTimer from "./components/RoomTimer/RoomTimer"
import RoomDiscussionInfo from "./components/RoomDiscussionInfo"
import RoomBroadcast from "./components/RoomBroadcast"
import RoomFacilitator from "./components/RoomFacilitatorInstruction"

const ChatBubble = (sender, message, fromOther, time) => {
	
	if(fromOther){
		return (
			`
			<div class="msg-other">
				<p class="sender sender-other">${sender}</p>
				<div class="talk-bubble">
					<div class="talktext">
						<p>${message}</p>
					</div>
					<div class="chat-time other">
						<p>${time}</p>
					</div>
				</div>
			</div>
			`
		);
	}
	return (
		`
		<div class="msg-me">
			<p class="sender sender-me">${sender}</p>
			<div class="talk-bubble me">
				<div class="talktext">
					<p>${message}</p>
				</div>
				<div class="chat-time me">
					<p>${time}</p>
				</div>
			</div>
		</div>
		`
	);
}

const Participant = (uid, name) => {
	return (
		`<div  class="video-container" id="user-container-${uid}">
			<div class="video-player" id="user-${uid}"></div>
			<div class="username-wrapper"><span class="user-name">${name}</span></div>
		</div>`
	);
}

const Screen = (uid, name) => {
	return (
		`<div  class="screen-container" id="user-container-${uid}">
			<div class="screen-player" id="user-${uid}"></div>
			<div class="username-wrapper"><span class="user-name">${name}</span></div>
		</div>`
	);
}

const ParticipantListItem = (uid, name, role) => {
	return (
		`<div  id="participat-list-${uid}" class="participant-list-item">
			<p class='participant-list-name'>${name}</p>
			<p class='participant-list-role'>${role}</p>
		</div>`
	);
}

const Room = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const messageRef = useRef()
	const infoRef = useRef()
	const broadcastRef = useRef()
	const msgContainerRef = useRef()
	const participantRef = useRef()
	const facilitatorInsRef = useRef()

	const APP_ID = 'dd86e959a39b455d8dd542e973adaf80'
	const TOKEN_DATA = location.state.tokenData
	const TOKEN = TOKEN_DATA.token
	const TOKEN_RTM = TOKEN_DATA.tokenRtm
	const TOKEN_SCREEN = TOKEN_DATA.tokenScreen

	const USER_DATA = location.state.userData
	const CHANNEL = (USER_DATA.index).toString()
	let UID = USER_DATA.uid_peserta
	let UID_SCREEN = USER_DATA.uid_screen
	let NAME = USER_DATA.nama_peserta
	let ROLE_PESERTA = USER_DATA.role_peserta
	let NPM = ROLE_PESERTA === 'HOST' ? "" : USER_DATA.npm_peserta

	let ROOM_NAME = location.state.roomName
	
	let SESSION_DATA = location.state.sessionData
	let TIME_END = SESSION_DATA.waktu_akhir
	

	const client = AgoraRTC.createClient({mode:'rtc', codec:'vp8'})
	const screenClient = AgoraRTC.createClient({
		mode: 'rtc',
		codec: 'vp8'
	});
	const clientRTM = AgoraRTM.createInstance(APP_ID)
	let localTracks = []
	let remoteUsers = {}
	let channelRTM = clientRTM.createChannel(CHANNEL);
	let screenTrack = null;
	const countDownDate = new Date(TIME_END).getTime();
	let diffTime = countDownDate - new Date().getTime()
	let [days, hours, minutes, seconds] = getTimeReturnValues(diffTime);
	let showWarningTimerEnds = true;

	useEffect(() => {
		window.history.forward();
	})

	useEffect(() => {

		if( (days !== 0 || hours !== 0 || minutes >= 5)
		 && (days + hours + minutes + seconds > 0)){
			joinAndDisplayLocalStream()
		}

		if (messageRef && messageRef.current) {
            messageRef.current.addEventListener("keypress", function(event) {
				if (event.key === "Enter") {
				  event.preventDefault();
				  // Trigger the button element with a click
				  document.getElementById("send-msg-button").click();
				}
			});
            return function cleanup() {
                 
            };
        }

		return () => {
			leaveAndRemoveLocalStream()
		}
	}, [])

	const redirectToPostcall = async () => {
		navigate("/postcall", {
			state:{
				userUid: UID,
				userName: NAME,
				userNpm: NPM,
				roomId: CHANNEL
			}
		});
	}

	const redirectToLobbyRoom = () => {
		navigate("/lobby", {
			state:{
				userData: location.state.userData, 
				sesi: location.state.sessionData
			}}
		);
	}

	let joinAndDisplayLocalStream = async () => {
		client.on('user-published', handleUserPublished)
		client.on('user-unpublished', handleUserUnpublished)
		client.on('user-joined', handleUserJoined)
		client.on('user-left', handleUserLeft)
		clientRTM.on('MessageFromPeer', handleMessageFromPeer)
		channelRTM.on('ChannelMessage',handleMessageFromPeer)

		try{	
			const token = TOKEN_RTM
			let uid = UID.toString()
			await clientRTM.login({uid, token})
			channelRTM.join()
		}catch(error){
			console.error("RTM ERROR" , error)
		}

		try {
			UID = await client.join(APP_ID, CHANNEL, TOKEN, UID)
		} catch(error) {
			console.error("RTC ERROR", error)
		}

		try {
			UID_SCREEN = await screenClient.join(APP_ID,CHANNEL,TOKEN_SCREEN,UID_SCREEN);
		} catch(error) {
			console.error("SCREEN ERROR", error)
		}
		
		localTracks = await AgoraRTC.createMicrophoneAndCameraTracks()

		let participant = Participant(UID, NAME)
		document.getElementById('video-streams').insertAdjacentHTML('beforeend', participant)
		localTracks[1].play(`user-${UID}`)
		
		await client.publish([localTracks[0], localTracks[1]])
		localTracks[1].setEnabled(false)
		localTracks[0].setEnabled(false)		
	}


	let handleUserPublished = async (user, mediaType) => {
		remoteUsers[user.uid] = user

		if(user.uid.toString() === UID_SCREEN.toString()){
			return
		}
		
		await client.subscribe(user, mediaType)

		try{
			let response = await getMember(user);
			if (response.data.role === "SCREEN"){
				let player = Screen(user.uid, response.data.member_name)
				document.getElementById('screen-streams').insertAdjacentHTML('beforeend', player)
			}
		}
		catch(e){
			console.log(e);
		}

		if (mediaType === 'video'){			
			user.videoTrack.play(`user-${user.uid}`)
		}

		if (mediaType === 'audio'){
			user.audioTrack.play()
		}

	}
	let handleUserUnpublished = async (user)=>{
		try{
			let response = await getMember(user);
			if (response.data.role === "SCREEN"){
				document.getElementById(`user-container-${user.uid}`).remove()
			}
		}
		catch(e){
			console.log(e);
		}
	}

	let handleSendMessage = async (e) => {
		e.preventDefault()		
		let message = messageRef.current.value
		if (message === '') return
		
		channelRTM.sendMessage({ text: message }).then(() => {
			let now = new Date();
			let chatBubble = ChatBubble(
				NAME, 
				message, 
				false, 
				(now.getHours() < 10 ? `0${now.getHours()}` : now.getHours()) 
				+ "." + 
				(now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes())
			)
			document.getElementById("message-container").insertAdjacentHTML("afterbegin",chatBubble)
			messageRef.current.value = null
		}).catch(error => {
			console.log(error)
		});
	}
	
	let handleUserJoined = async (user) =>{
		if(user.uid.toString() === UID_SCREEN.toString()){
			return
		}
		try{
			let member = await getMember(user)
			if (member.data.role === "PARTICIPANT") {
				let participant = Participant(user.uid, 
					member.data.member_name)
				document.getElementById('video-streams').insertAdjacentHTML(
					'beforeend', 
					participant)
				let participantList = ParticipantListItem(
					user.uid, 
					member.data.member_name, 
					member.data.member_role)
				document.getElementById('participants-list-container').insertAdjacentHTML(
					'beforeend', 
					participantList)
			}
		}
		catch (e){
			console.log(e)
		}
	}
	
let handleMessageFromPeer = async (message,user) => {
	let member = await getMemberFromMessage(user)		
	let now = new Date();
	NotificationManager.info(
		'New incoming message', 
		'Message');
	let chatBubblePeer = ChatBubble(
		member.data.member_name, 
		message.text, true, 
		(now.getHours() < 10 ? `0${now.getHours()}` : now.getHours()) 
		+ "." + 
		(now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes()))
	document.getElementById("message-container").insertAdjacentHTML("afterbegin",chatBubblePeer)
}

	let handleUserLeft = async (user) => {
		delete remoteUsers[user.uid]
		document.getElementById(`user-container-${user.uid}`).remove()
		document.getElementById(`participat-list-${user.uid}`).remove()
	}

	let handleShareScreen = async(e) => {
		if(screenTrack !== null){
			screenTrack.close();
			document.getElementById(`user-container-${UID_SCREEN}`).remove()
			screenTrack = null
			e.target.style.backgroundColor = '#EB3223'
			return
		}
		screenTrack = await AgoraRTC.createScreenVideoTrack();
		let screenShare = Screen(UID_SCREEN, "Your Screen")
		document.getElementById('screen-streams').insertAdjacentHTML('beforeend', screenShare)
		screenTrack.play(`user-${UID_SCREEN}`)
		screenTrack.on("track-ended", () => {
			screenTrack && screenTrack.close();
			screenTrack = null
			e.target.style.backgroundColor = '#EB3223'
			document.getElementById(`user-container-${UID_SCREEN}`).remove()
		  });
		await screenClient.publish(screenTrack);
		e.target.style.backgroundColor = '#fff'
		return screenClient;
	
	} 

	let leaveAndRemoveLocalStream = async () => {
		let diffTime = countDownDate - new Date().getTime()
		let [days, hours, minutes, seconds] = getTimeReturnValues(diffTime);

		if( days !== 0 || hours !== 0 || minutes >= 5){
			confirmAlert({
				title: 'Discussion has not ended',
				message: "Postcall can be accessed in the last 5 minutes",
				buttons: [
					{
					label: 'OK',
					onClick: () => null
					}
				]
				});
			return
		}

		for (let i=0; localTracks.length > i; i++){
			localTracks[i].stop()
			localTracks[i].close()
		}

		await client.leave()
		redirectToPostcall()
		//This is somewhat of an issue because if user leaves without actaull pressing leave button, it will not trigger
		// deleteMember()
		// window.open('/', '_self')
	}

	let backToLobby = async () => {
		for (let i=0; localTracks.length > i; i++){
			localTracks[i].stop()
			localTracks[i].close()
		}

		await client.leave()
		deleteMember()
		redirectToLobbyRoom()
		
	}

	let toggleCamera = async (e) => {
		if(localTracks[1].enabled){
			await localTracks[1].setEnabled(false)
			e.target.style.backgroundColor = '#EB3223'
		}else{
			await localTracks[1].setEnabled(true)
			e.target.style.backgroundColor = '#fff'
		}
	}

	let toggleMic = async (e) => {
		if(localTracks[0].enabled){
			await localTracks[0].setEnabled(false)
			e.target.style.backgroundColor = '#EB3223'
		}else{
			await localTracks[0].setEnabled(true)
			e.target.style.backgroundColor = '#fff'
		}
	}

	let getMember = async (user) => {
		let response = await fetch(`https://backend-ta-wiyata.herokuapp.com/get-member/${user.uid}/`)
		let member = await response.json()
		return member
	}
	let getMemberFromMessage = async (user) => {
		let response = await fetch(`https://backend-ta-wiyata.herokuapp.com/get-member/${user}/`)
		let member = await response.json()
		return member
	}

	let deleteMember = async () => {
		await fetch('https://backend-ta-wiyata.herokuapp.com/delete-member/', {
			method:'POST',
			headers: {
				'Content-Type':'application/json'
			},
			body:JSON.stringify({'uid':UID})
		})
	}

	const handleAskFacilitator = async () => {
		const data = { 'id_ruang_diskusi':  USER_DATA.index};
		try {
			await axios.post(
				'https://backend-ta-wiyata.herokuapp.com/call-host/', 
				data);
			NotificationManager.info(
				'Host has been notified. Please wait until the host comes.', 
				'Success');
		} catch (e) {
			console.log(e)
		}
		
	}

	const onAskFacilitatorClicked = () => {
		confirmAlert({
			title: 'Ask for Host',
			message: 'Are you sure you want to invite the host to this room?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => handleAskFacilitator()
				},
				{
					label: 'No',
					onClick: () => null
				},
			]
			});
	}

	const handleWarningTimerEnds = () => {
		if (showWarningTimerEnds){
			showWarningTimerEnds = false;
			NotificationManager.warning(
				'The session will be closed in 10 seconds', 
				"You will be redirected to Postcall",
				5000);
		}
	}

	const handleShowInfo = () => {
		if(infoRef !== null){
			if (infoRef.current.style.display === 'none' || infoRef.current.style.display === ""){
				infoRef.current.style.display = 'block'
			} else {
				infoRef.current.style.display = 'none'
			}
		}
	}

	const toggleBroadcast = () => {
		if (broadcastRef !== null){
			if (broadcastRef.current.style.visibility === 'hidden' 
				|| broadcastRef.current.style.visibility === ""){
				broadcastRef.current.style.visibility = 'visible'
			} else {
				broadcastRef.current.style.visibility = 'hidden'
			}
		}

		if (msgContainerRef !== null){
			msgContainerRef.current.style.visibility = 'hidden'
		}

		if (participantRef !== null){
			participantRef.current.style.visibility = 'hidden'
		}

		if (facilitatorInsRef !== null){
			facilitatorInsRef.current.style.visibility = 'hidden'
		}
	}

	const toggleMessage = () => {
		if (msgContainerRef !== null){
			if (msgContainerRef.current.style.visibility === 'hidden' || msgContainerRef.current.style.visibility === ""){
				msgContainerRef.current.style.visibility = 'visible'
			} else {
				msgContainerRef.current.style.visibility = 'hidden'
			}
		}

		if (broadcastRef !== null){
			broadcastRef.current.style.visibility = 'hidden'
		}

		if (participantRef !== null){
			participantRef.current.style.visibility = 'hidden'
		}

		if (facilitatorInsRef !== null){
			facilitatorInsRef.current.style.visibility = 'hidden'
		}

	}

	const toggleParticipant = () => {
		if(participantRef !== null){
			if (participantRef.current.style.visibility === 'hidden' || participantRef.current.style.visibility === ""){
				participantRef.current.style.visibility = 'visible'
			} else {
				participantRef.current.style.visibility = 'hidden'
			}
		}

		if(broadcastRef !== null){
			broadcastRef.current.style.visibility = 'hidden'
		}

		if(msgContainerRef !== null){
			msgContainerRef.current.style.visibility = 'hidden'
		}

		if (facilitatorInsRef !== null){
			facilitatorInsRef.current.style.visibility = 'hidden'
		}
	}

	const toggleFacilitatorIns = () => {
		if(facilitatorInsRef !== null){
			if (facilitatorInsRef.current.style.visibility === 'hidden' || facilitatorInsRef.current.style.visibility === ""){
				facilitatorInsRef.current.style.visibility = 'visible'
			} else {
				facilitatorInsRef.current.style.visibility = 'hidden'
			}
		}

		if(broadcastRef !== null){
			broadcastRef.current.style.visibility = 'hidden'
		}

		if(msgContainerRef !== null){
			msgContainerRef.current.style.visibility = 'hidden'
		}

		if (participantRef !== null){
			participantRef.current.style.visibility = 'hidden'
		}
	}

	return (
		<div className="fullpage discussion-room-page">
			<div className="non-controller-container">
				<section id="room-name-wrapper">
					<div className="header-discussion-room">
						<RoomTimer 
							time={TIME_END} 
							role={ROLE_PESERTA}
							redirectToPostcall={redirectToPostcall}
							redirectToLobby={backToLobby}
							handleWarningTimerEnds={handleWarningTimerEnds}
						/>
						<div class="profile-discussion-room">
							<p>{NAME}</p>
							<p>{ROLE_PESERTA}</p>
							<p>{NPM}</p>
						</div>
					</div>
					
					<div className="room-name-section">
						<p className='room-name'>{ROOM_NAME}</p>
						<div 
							className='back-lobby-button'
							onClick={backToLobby} >
							{`< Lobby Room`}
						</div>
					</div>
					
					
				</section>

				<div className="main-feature-container">
					<section className="streams">
						<div id="screen-streams" />
						<div id="video-streams" />

						<div id="controls-wrapper">

							<div className="show-info" onClick={handleShowInfo}>
								<img 
									className="info-diskusi-logo" 
									src={infoDiskusiLogo} 
									alt="info diskusi logo"
									/>
								<p className='info-diskusi-text'>{SESSION_DATA['topik_diskusi']}</p>
							</div>
							<div className="control-wrapper-main">
								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">Microphone</span>
									<img 
										className="control-icon" 
										id="mic-btn" 
										src={microphone} 
										alt="microphone"
										onClick={toggleMic}
										/>
								</div>

								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">Video</span>
									<img 
										className="control-icon" 
										id="camera-btn" 
										src={video} 
										alt="video"
										onClick={toggleCamera}
										/>
								</div>

								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">Share Screen</span>
									<img 
									className="control-icon" 
									id="share-screen-btn" 
									src={shareScreen}
									alt="shareScreen" 
									onClick={handleShareScreen}
									/>
								</div>
								{
									ROLE_PESERTA === "STUDENT" && 
									<>
										<div className="icon-wrapper tooltip">
											<span class="tooltiptext">Ask Facilitator</span>
											<img 
											className="control-icon white" 
											id="ask-facilitator-btn" 
											src={askFacilitator}
											alt="ask facilitator" 
											onClick={onAskFacilitatorClicked}
											/>
										</div>
										<div className="icon-wrapper tooltip">
											<span class="tooltiptext">End Discussion</span>
											<img 
											className="control-icon" 
											id="leave-btn" 
											src={leave}
											alt="leave" 
											onClick={leaveAndRemoveLocalStream}
											/>
										</div>
									</>
									
								}
								
							</div>

							<div className="control-helper">
								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">Broadcast</span>
									<img 
										className="control-icon-helper" 
										id="broadcast-btn" 
										src={broadcastLogo} 
										alt="broadcast"
										onClick={toggleBroadcast}
										/>
								</div>

								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">Chat</span>
									<img 
										className="control-icon-helper" 
										id="chat-btn" 
										src={chatLogo} 
										alt="chat"
										onClick={toggleMessage}
										/>
								</div>

								<div className="icon-wrapper tooltip">
									<span class="tooltiptext">List of Participants</span>
									<img 
										className="control-icon-helper" 
										id="participant-btn" 
										src={participantLogo}
										alt="participants" 
										onClick={toggleParticipant}
									/>
								</div>

								{
									ROLE_PESERTA === "HOST" &&
									<div className="icon-wrapper tooltip">
										<span class="tooltiptext">Facilitator Instruction</span>
										<img 
											className="control-icon-helper" 
											id="participant-btn" 
											src={facilitatorInstructionLogo}
											alt="facilitator Instruction" 
											onClick={toggleFacilitatorIns}
										/>
									</div>
								}
								
							</div>

						</div>
							
					</section>
					<NotificationContainer/>
					
				</div>

				<div id="message-section" 
					className="discussion-room-card discussion-room-chat"
					ref={msgContainerRef}>
					<p className='card-list-title'>Messages</p>					
					<div className="message-in-out">
						<div id="message-container" />
						<div className="message-form">
							<div className="message-input">
								<input 
									type="text" 
									name="message" 
									className="message-input-type"
									placeholder="Enter message..."
									ref={messageRef}
									autoComplete="off"
								/>
								<img 
									className="send-message-button"
									id="send-msg-button"
									onClick={handleSendMessage}
									src={sendMessageLogo}
									alt="send message button" 
								/>
							</div>
						</div>
					</div>
				</div>

				<div 
					className='discussion-room-card discussion-room-participants'
					ref={participantRef}
					id='participants-list-container'
					>
					<p className='card-list-title'>Members of this room</p>
					<div id={`participat-list-${UID}`} className='participant-list-item'>
						<p className='participant-list-name'> {NAME + (ROLE_PESERTA === "STUDENT" ? " - " + USER_DATA.npm_peserta : "")} <span style={{'color': '#0083FB'}}>(You)</span></p>
						<p className='participant-list-role'>{ROLE_PESERTA}</p>
					</div>
				</div>

				<RoomDiscussionInfo sessionData={SESSION_DATA} role={ROLE_PESERTA} infoRef={infoRef} />
				<RoomBroadcast sessionData={SESSION_DATA} broadcastRef={broadcastRef} />
				<RoomFacilitator sessionData={SESSION_DATA} facilitatorInsRef={facilitatorInsRef} />
				
			</div>
		</div>
	);
}
 
export default Room;